<template>
    <span class="entity-type-label">
        {{entityLabel}}
    </span>
</template>

<script>

import { getEntityTypeLabel } from '../nlu-model/sidebar/entities/entity-types'
export default {
  name: 'EntityTypeLabel',

  props: {
    entityType: String
  },

  computed: {
    entityLabel () {
      return getEntityTypeLabel(this.$props.entityType)
    }
  }
}
</script>

<style scoped lang="scss">
    .entity-type-label {
        width: 20px;
        height: 16px;
        color: rgb(198, 198, 198);
        font-size: 14px;
        font-weight: 600;
        letter-spacing: -0.45px;
        text-align: center;
    }
</style>
